module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'mc-editor-fullwidth': _vm.isFullWidth
    },
    attrs: {
      "id": _vm.vueUEditorId
    }
  }, [_c('VueUEditor', {
    staticClass: "editor-wrap",
    attrs: {
      "ueditorPath": _vm.config.AjaxUrl + '/Content/Plug-in-unit/utf8-net/'
    },
    on: {
      "ready": _vm.editorReady
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-4ada63c7","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/libcomponents/mc-editor/mc-editor.vue
// module id = 762
// module chunks = 1